import { PurchasesScreen } from './PurchasesScreen.jsx';

export default {
  path: '/purchase/*',
  element: <PurchasesScreen />,
  protected: true,
  permission: 'inventory.purchase.view',
  standalone: false,
  sidebar: { label: 'المشتريات', icon: 'purchase', group: 'inventory', order: 71 }
};
